import React, { useState } from "react";
import "./AboutCard.css";
import Icon1 from "../../../assets/icons/icon1.gif";
import Icon2 from "../../../assets/icons/icon2.gif";
import Icon3 from "../../../assets/icons/icon3.gif";
import Icon4 from "../../../assets/icons/icon4.gif";
import AuthModal from "../../Frontend/Membership/AuthModal/AuthModal";

const items = [
    {
        icon: Icon1,
        title: "Engagement & Intent to Stay",
        text: "Actively engage with fellow members; consistent participation builds visibility and credibility.",
    },
    {
        icon: Icon2,
        title: "Inclusion",
        text: "When introducing others, emphasise mutual benefit — inclusion creates lasting opportunities.",
    },
    {
        icon: Icon3,
        title: "Well-being & Relationships",
        text: "Balance business with genuine personal interaction to nurture #TrueRelationships and positivity.",
    },
    {
        icon: Icon4,
        title: "Experience over Expectations",
        text: "Share experiences rather than promises — strong experiences build trust and reduce friction.",
    },
];

export default function AboutCard() {
      const [showAuth, setShowAuth] = useState(false);
    return (
        <section className="about-cards-section mb-2" aria-label="About cards">
            <div className="about-cards">
                {items.map((it, idx) => (
                    <article
                        className="about-card"
                        key={it.title}
                        style={{ ['--delay']: `${idx * 120}ms` }}
                        tabIndex={0}
                        aria-labelledby={`about-title-${idx}`}
                    >
                        <div className="about-card-icon">
                            <img src={it.icon} alt="icon" aria-hidden className="about-icon-img" />
                        </div>

                        <div className="about-card-content">
                            <h3 id={`about-title-${idx}`} className="about-card-title">{it.title}</h3>
                            <p className="about-card-text">{it.text}</p>
                        </div>
                    </article>
                ))}
               
            </div>
                  <button
                  className="join-now mt-3 mx-auto mb-1"
                  onClick={() => setShowAuth(true)}>

                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="currentColor"></path>
                  </svg>
                  <span className="text-light">Join Now</span>

                </button>
                  <AuthModal
        isOpen={showAuth}
        onClose={() => setShowAuth(false)}
      />
        </section>
    );
}